<template>
  <div class="propject_detail_info_table">
    <div class="flex-row project_table_thead">
      <span class="propject_detail_info_table_cell company-files-cell-0 propject_detail_info_label">类型</span>
      <span class="propject_detail_info_table_cell company-files-cell-1 propject_detail_info_label col-1">文件名</span>
      <span class="propject_detail_info_table_cell company-files-cell-2 propject_detail_info_label">上传人</span>
      <span class="propject_detail_info_table_cell company-files-cell-3 propject_detail_info_label mr5">操作</span>
    </div>
    <div class="propject_detail_info_table col-1 scroll h300">
      <div v-for="(value, i) in files" :key="i" :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`">
        <span class="propject_detail_info_table_cell company-files-cell-0 col-0">{{ value.type }}</span>
        <a class="propject_detail_info_table_cell company-files-cell-1 col-1" @click="preview(value)">{{
          value.originalname
        }}</a>
        <span class="propject_detail_info_table_cell company-files-cell-2 col-0">{{
          handleUploader(value.uploader)
        }}</span>
        <span class="propject_detail_info_table_cell company-files-cell-3 col-0">
          <a v-if="userInservice" class="mr5" @click="download(value)">下载</a>
          <a v-if="couldDelete" class="ft-danger" @click="deleteFile(value, i)">删除</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { download } from '../../../project/src/constant/utils.js'

export default {
  props: {
    files: { type: Array, default: () => [] },
    couldDelete: { type: Boolean, default: false },
  },
  data() {
    return {
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
  },
  methods: {
    handleUploader(uploader) {
      return Array.isArray(uploader) ? uploader.join('、') : uploader
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    async deleteAtta(value, index) {
      this.$emit('deleteFile', value)
    },
  },
}
</script>
